module.exports = __webpack_public_path__ + "static/media/fragile.cd8c2be7.svg";